/**
 * @package Bears Elements VC
 * @author Bearsthemes
 */

import PriorityNav from 'priority-nav';
import FuryGrid from './modules/jquery.furygrid.js';
import jQueryCountdown from './modules/jquery.countdown.js';

!(function(w, $) {
  'use strict';

  /**
   * modules
   */
  require('./modules/once');

  var BearsElementsVC = function () {

    /**
     * Visual Conposer Frontend Builder
     */
    this.FrontendBuilderApplyScript = function() {
      var _InterValLoop,
          self = this;

      _InterValLoop = setInterval(function() {
        self.OnceHandle();
      }, 500)
    }

    /**
     * Once handle
     */
    this.OnceHandle = function () {
      this.SlickCarousel();
      this.SlickFilter();
      this.FuryGrid();
      this.FuryGridFilterNav();
      this.FuryGridHasLoadMore();
      this.FuryGridLoadMoreButton_AddCallback();
      this.PriorityNav();
      this.CatListAccordionStyle();
      this.lightcase();
      this.countdown();
      this.imageLazyLoad();
    }

    /**
     * Slick carousel
     */
    this.SlickCarousel = function () {
      $('*[data-bevc-slick]')._once(function() {
        var $thisEl = $(this),
            Clone = $thisEl.find('> *').clone(),
            options = $thisEl.data('bevc-slick'),
            opt_rows = options.rows;

        options.nextArrow = '<div class="custom-slick-next"><img src="'+ bevc_object.images.arrow_next +'" alt="'+ bevc_object.language.TEXT_NEXT +'"></div>';
        options.prevArrow = '<div class="custom-slick-prev"><img src="'+ bevc_object.images.arrow_prev +'" alt="'+ bevc_object.language.TEXT_PREV +'"></div>';
        
        
        if( $thisEl.data('bevc-slick-custom-nav') == true ) {
          // console.log( $thisEl.data('bevc-slick-custom-nav') );
          var $_parent = $thisEl.parent();
          // console.log( $_parent.find('[data-bevc-slick-custom-nav-prev]') );
          if( $_parent.find('[data-bevc-slick-custom-nav-prev]').length > 0 ) {
            options.prevArrow = $_parent.find('[data-bevc-slick-custom-nav-prev]');
          }

          if( $_parent.find('[data-bevc-slick-custom-nav-next]').length > 0 ) {
            options.nextArrow = $_parent.find('[data-bevc-slick-custom-nav-next]');
          }
        }

        // add slick slide
        var SlickObject = $thisEl.slick(options);
        var $SlickEl = $(this);

        if( $thisEl.data('bevc-slick-custom-control') == true ) {
          var $_parent = $thisEl.parent();
          
          $_parent.on('change', '*[data-bevc-slick-custom-control]', function(e) {
            var $field = $(this);
            var field_type = $field.attr('type');
            var opt_name = $(this).data('bevc-slick-custom-control');
            
            if( field_type == 'checkbox' ) {
              var value = false
              if( $field.is(':checked') ) {
                value = true
              }
            } else {
              var value = $field.val();
            }
            
            options[opt_name] = value;
            SlickObject.slick('unslick').slick(options);
          })
        }

        var FilterEffect_Handle = {
          'slide-up': {
            hide (SlideItems) {
              var NumIncrease = 0;

              SlideItems.css('opacity', 0)
              .each(function() {
                $(this).css({
                  transition: 'opacity .5s cubic-bezier(.68,.12,.49,.88), transform .5s cubic-bezier(.68,.12,.49,.88)',
                  transform: 'translateY(20%)',
                  transitionDelay: 0.1 + NumIncrease * 0.1 + 's',
                })

                NumIncrease += 1;
              })
            },
            show (SlideItems) {
              SlideItems.css({
                opacity: 1,
                transform: 'translateY(0)',
              });
            }
          },
          'zoom-in': {
            hide (SlideItems) {
              var NumIncrease = 0;

              SlideItems.css('opacity', 0)
              .each(function() {
                $(this).css({
                  transition: 'opacity .5s cubic-bezier(.68,.12,.49,.88), transform .5s cubic-bezier(.68,.12,.49,.88)',
                  transform: 'scale(1.3)',
                  transitionDelay: 0.1 + NumIncrease * 0.1 + 's',
                })

                NumIncrease += 1;
              })
            },
            show (SlideItems) {
              SlideItems.css({
                opacity: 1,
                transform: 'scale(1)',
              });
            }
          },
          'zoom-out': {
            hide (SlideItems) {
              var NumIncrease = 0;

              SlideItems.css('opacity', 0)
              .each(function() {
                $(this).css({
                  transition: 'opacity .5s cubic-bezier(.68,.12,.49,.88), transform .5s cubic-bezier(.68,.12,.49,.88)',
                  transform: 'scale(.7)',
                  transitionDelay: 0.1 + NumIncrease * 0.1 + 's',
                })

                NumIncrease += 1;
              })
            },
            show (SlideItems) {
              SlideItems.css({
                opacity: 1,
                transform: 'scale(1)',
              });
            }
          },
        }
        
        // add slick filter
        $thisEl.on({
          '_count_item_by_class.bevc-slick-slide' (e, className) {
            return Clone.filter(className).length;
          },
          '_filter.bevc-slick-slide' (e, filter, effect) {
            var filterSlides = (filter == '*') ? Clone.clone() : Clone.filter(filter);

            // do effect hide
            (FilterEffect_Handle[effect]) ? FilterEffect_Handle[effect].hide(filterSlides) : '';
            
            // apply slick slide
            var NewOptions = function() {
              if(filter != '*') options.rows = 1
              else options.rows = opt_rows;
              return options;
            }
            
            SlickObject.slick('unslick').html('').append(filterSlides).slick(NewOptions());

            // do effect show
            (FilterEffect_Handle[effect]) ? FilterEffect_Handle[effect].show(filterSlides) : '';
            
          }
        })
      })
    }

    this.SlickFilter = function () {
      $('*[data-bevc-slick-has-filter]')._once(function() {
        var $thisEl = $(this),
            $NavEl = $thisEl.find('[data-bevc-slick-filter-nav]'),
            $SlickSlideEl = $thisEl.find('[data-bevc-slick]'); 

        var FitterEffectAvailable = ['slide-up', 'zoom-in', 'zoom-out'];
        var NavTotalNumber = $NavEl.data('nav-total-number');

        $NavEl.on({
          '_count.bevc-slick-has-filter' (e) {
            $(this).find('[data-bevc-filter-item]').each(function() {
              var number = $SlickSlideEl.triggerHandler('_count_item_by_class', [$(this).data('bevc-filter-name')]);
              
              $(this).append(`<span class="badge-count-number">${number}</span>`);
            })
          }
        })

        if(NavTotalNumber == 'show') { $NavEl.trigger('_count'); }

        $NavEl.on('click.bevc-slick-has-filter', '[data-bevc-filter-item]', function(e) {
          e.preventDefault();

          var FilterEffect = $NavEl.data('bevc-slick-filter-effect');

          if(FilterEffect == 'random') {
            FilterEffect = FitterEffectAvailable[Math.floor(Math.random() * FitterEffectAvailable.length)];
          }

          $SlickSlideEl.trigger('_filter', [$(this).data('bevc-filter-name'), FilterEffect]);

          $NavEl.find('._fillter-current').removeClass('_fillter-current');
          $(this).addClass('_fillter-current');
        })
        
      })
    }

    this.FuryGrid = function() {
      $('*[data-bevc-furygrid]')._once(function() {
        var $thisEl = $(this),
            opts = $.extend({
              El        : this,
              Col 			: 4,
			        Space 		: 24,
            }, $thisEl.data('bevc-furygrid'));
        
        if($thisEl.data('bevc-furygrid-col')) opts.Col = $thisEl.data('bevc-furygrid-col')
        if($thisEl.data('bevc-furygrid-space')) opts.Col = $thisEl.data('bevc-furygrid-space')

        var FuryGrid_Object = new FuryGrid(opts);
        $thisEl.data('bevc-furygrid-object', FuryGrid_Object);
      })
    }

    this.FuryGridFilterNav = function() {
      $('*[data-bevc-furygrid-has-filter-nav]')._once(function() {
        var $this = $(this),
            $furyGridEl = $this.find("[data-bevc-furygrid]").first(),
            furyGridObject = $furyGridEl.data('bevc-furygrid-object'),
            opts = $.extend({
              'nav_el': '.bevc-furygrid-filter-nav',
            }, $this.data('bevc-furygrid-has-filter-nav'));
        
        var $navEl = $(opts.nav_el); 
        if( $furyGridEl.length <= 0 || $navEl.length <= 0 ) return;
        
        var IsotopGrid = furyGridObject.GetIsotopeGrid(); 
        $this.find('[data-furygrid-filter-item]').on('click', function(e) {
          e.preventDefault();

          IsotopGrid.arrange({
            filter: $(this).data('furygrid-filter-item'),
          })

          $(this).addClass('_is-active').siblings().removeClass('_is-active');
        })
      })
    }
    
    this.FuryGridHasLoadMore = function() {
      $('*[data-bevc-furygrid-ajax-has-load-more]')._once(function() {
        var $this = $(this),
            $btnLoadmoreEl = $this.find('[data-bevc-furygrid-ajax-load-more-btn]').first(),
            $furyGridEl = $this.find('[data-bevc-furygrid]').first();
       
        if( $btnLoadmoreEl.length <= 0 || $furyGridEl.length <= 0 ) return;
        
        var furyGridObject = $furyGridEl.data('bevc-furygrid-object'),
            IsotopGrid = furyGridObject.GetIsotopeGrid();

        var LoadmoreOpts = $.extend({
          'action': '',
          'extra_params': '',
        }, $btnLoadmoreEl.data('bevc-furygrid-ajax-load-more-btn'));

        $btnLoadmoreEl.on({
          'ajax_loading' (e, is_loading) {
            if( true == is_loading ) {
              $(this).addClass( '_is-loading' );
            } else {
              $(this).removeClass( '_is-loading' );
            }
          },
          'do_callbacks' (e, data) {
            var $thisEl = $(this);
            var callbacks = $thisEl.data('bevc-furygrid-ajax-load-more-callbacks');
            if( ! callbacks || callbacks.length <= 0 ) return;

            // callback is array functions
            if( Array.isArray( callbacks ) ) {
              callbacks.forEach(function(_fn) {
                _fn.call($thisEl, data);
              })
              return;
            }

            // callback is function
            if( typeof callbacks === 'function' ) {
              callbacks.call($thisEl, data);
              return;
            }
          }
        })

        $btnLoadmoreEl.on('click', function(e) {
          e.preventDefault();
          var $thisEl = $(this);
          
          $thisEl.trigger('ajax_loading', [true]);
          $.ajax({
            type: 'POST',
            url: bevc_object.ajax_url,
            data: LoadmoreOpts,
            success (res) {
              $thisEl.trigger('ajax_loading', [false]);

              if( res.success == true ) {
                var data = res.data; 
                if( data.content != '' ) {
                  var $items = $(data.content);
                  
                  $items.children().each(function() {
                    var $thisItem = $(this);
                    
                    $thisItem.css({
                      opacity: 0,
                      transition: '.4s ease',
                      transform: 'translateY(20px)',
                      transitionDelay: $thisItem.parent().index() * 0.1 + 's',
                    })
                  })
                  
                  if( data.extra_params ) { LoadmoreOpts.extra_params = data.extra_params; } 

                  $furyGridEl.append( $items );
                  IsotopGrid.appended( $items );
                  IsotopGrid.layout();

                  setTimeout(function() { 
                    IsotopGrid.layout(); 
                    
                    $items.children().each(function() {
                      var $thisItem = $(this);
                      $thisItem.css({
                        opacity: 1,
                        transform: 'translateY(0)',
                      })
                    })

                    $thisEl.trigger('do_callbacks', [data])
                  }, 500);
                }
              }
            },
            error (e) {
              console.log(e);
            }
          })
        })
      })
    }

    this.FuryGridLoadMoreButton_AddCallback = function() {
      $('*[data-bevc-furygrid-ajax-load-more-btn]')._once(function() {
          var $this = $(this);
          var callbacks = $this.data('bevc-furygrid-ajax-load-more-callbacks');
          var _callbacks = (callbacks) ? callbacks : [];
          var max_num_pages = $this.data('max-num-pages');

          _callbacks.push(function(data) { 
            if( ! data.extra_params || ! data.extra_params.paged ) return;

            if( data.extra_params.paged > max_num_pages ) {
              $this.fadeOut('slow', function() {
                $this.remove();
              })
            }
          })

          $this.data('bevc-furygrid-ajax-load-more-callbacks', _callbacks);
      })
    }

    this.PriorityNav = function () {
      $('*[data-bevc-priority-navigation]')._once(function() {  
        var $thisEl = $(this),
            randClass = 'bevc-element-rand-item-' + Math.random().toString(36).substring(7);
        
        // add rand class
        $thisEl.addClass(randClass);

        var params = $.extend({
          mainNavWrapper: '.' + randClass, // mainnav wrapper selector (must be direct parent from mainNav)
          mainNav: '[data-main-nav]', // mainnav selector. (must be inline-block)
          navDropdownLabel: bevc_object.language.TEXT_MORE,
          navDropdownBreakpointLabel: bevc_object.language.TEXT_FILTER,
          navDropdownClassName: "nav__dropdown", // class used for the dropdown.
          navDropdownToggleClassName: "nav__dropdown-toggle", // class used for the dropdown toggle.
        }, {
          navDropdownLabel: ($thisEl.data('nav-dropdown-label')) ? $thisEl.data('nav-dropdown-label') : bevc_object.language.TEXT_MORE,
          navDropdownBreakpointLabel: ($thisEl.data('nav-dropdown-breakpoint-label')) ? $thisEl.data('nav-dropdown-breakpoint-label') : bevc_object.language.TEXT_FILTER,
          navDropdownClassName: ($thisEl.data('nav-dropdown-class-name')) ? $thisEl.data('nav-dropdown-class-name') : "nav__dropdown",
          navDropdownToggleClassName: ($thisEl.data('nav-dropdown-toggle-class-name')) ? $thisEl.data('nav-dropdown-toggle-class-name') : "nav__dropdown-toggle",
        })

        PriorityNav.init(params);
      })
    }

    this.CatListAccordionStyle = function() {
      $('[data-bevc-cat-list-accordion-style]')._once(function() {
        var $thisEl = $(this),
            opts = $.extend({
              parentEl: 'li',
              childrenEl: 'ul',
            }, $thisEl.data('bevc-cat-list-accordion-style'));
        

        $thisEl.find( opts.parentEl ).each(function() {
          var $parentEl = $(this);

          if( $parentEl.children(opts.childrenEl).length > 0 ) {
            var $childrenEl = $parentEl.children(opts.childrenEl);
            var $toogleButtonEl = $('<span class="btn-toogle"><i class="fa fa-angle-down" aria-hidden="true"></i></span>');
            
            $toogleButtonEl.on('click', function(e) {
              e.preventDefault();
              $parentEl.toggleClass( '_is-toogle-active' );

              if( $parentEl.hasClass('_is-toogle-active') ) {
                $childrenEl.stop(true, true).slideDown('slow');
              } else {
                $childrenEl.stop(true, true).slideUp('slow');
              }
              
            })
            
            $parentEl.prepend($toogleButtonEl);
          }
        })
      })
    }

    this.lightcase = function() {
      $('a[data-rel^=lightcase]').lightcase();
    }

    this.countdown = function() {
      $('[data-bevc-element-jquery-countdown]')._once(function() { 
        var $this = $(this);
        var data = $this.data('bevc-element-jquery-countdown');
        var pattern = [
          '<label><span>%-w</span> week%!w</label>',
          '<label><span>%-d</span> day%!d</label>',
          '<label><span>%H</span> hr</label>',
          '<label><span>%M</span> min</label>',
          '<label><span>%S</span> sec</label>',
        ].join('');
        
        if( $this.find('.jquery-countdown-custom-pattern').length > 0 ) {
          pattern = $this.find('.jquery-countdown-custom-pattern').html();
        }

        $this.countdown(data, function(event) {
          $(this).html(event.strftime(pattern));
        })
      })
    }

    this.imageLazyLoad = function() {
      $('img[data-bevc-lazy-load-image]').each(function() {
          var $image = $(this);
          var src = $image.data('bevc-lazy-load-image');
          if(! src) return;

          var _img = new Image();

          _img.onload = function() {
              $image.attr( 'src', src );
              $image.removeAttr('srcset');
          }
          _img.src = src;
      })
    }

    return this;
  }

  w.BearsElementsVC = w.BearsElementsVC || new BearsElementsVC();

  /** */
  function BEVC_Fix_Row_Stretch() {
    setTimeout(function() {$(w).trigger('resize');}, 100)
  }

  var bevc_product_categories_slide_toogle_nav_func = function() {
    $('.bevc_product_categories_slide').on('click', '.p-category-vertical-nav__toogle-on-mobile', function(e) {
      e.preventDefault();
      $(this).closest('.bevc_product_categories_slide').toggleClass('p-category-vertical-nav__is-active');
    })
  }

  /* DOM Ready */
  $(function() {
    // console.log(bevc_object);
    // call OnceHandle
    w.BearsElementsVC.OnceHandle();

    // fix vc row stretch
    BEVC_Fix_Row_Stretch();

    // 
    bevc_product_categories_slide_toogle_nav_func();
  })

  /* Browser load complete */
  $(w).load(function() {

  })

})(window, jQuery)
